import styled from "styled-components";
import { Flex } from "../Styles";

const Title = styled.span`
  color: ${(props) => props.theme.colors.light};
  font-size: clamp(2rem, 1vw + 1.5rem, 4rem);
`;

const ComingSoon = () => {
  return (
    <Flex>
      <Title>Rest is coming Soon</Title>
    </Flex>
  );
};

export default ComingSoon;
